import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from 'react';
import styled, { css } from 'styled-components';
import { theme } from '@styles/theme';
const InputWrapper = styled.div `
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing.xs};
  ${({ $fullWidth }) => $fullWidth && css `width: 100%;`}
`;
const Label = styled.label `
  font-size: ${theme.typography.fontSize.sm};
  font-weight: ${theme.typography.fontWeight.medium};
  color: ${theme.colors.text.primary};
`;
const InputContainer = styled.div `
  display: flex;
  align-items: center;
  gap: ${theme.spacing.sm};
  padding: ${theme.spacing.sm} ${theme.spacing.md};
  background-color: ${theme.colors.background.secondary};
  border: 1px solid ${({ $hasError }) => ($hasError ? theme.colors.status.error : theme.colors.border.primary)};
  border-radius: ${theme.borderRadius.md};
  transition: all ${theme.transitions.fast};

  &:focus-within {
    border-color: ${({ $hasError }) => ($hasError ? theme.colors.status.error : theme.colors.accent.primary)};
    box-shadow: 0 0 0 2px ${({ $hasError }) => $hasError ? `${theme.colors.status.error}33` : `${theme.colors.accent.primary}33`};
  }

  ${({ $disabled }) => $disabled &&
    css `
      opacity: 0.5;
      cursor: not-allowed;
    `}
`;
const StyledInput = styled.input `
  flex: 1;
  background: transparent;
  border: none;
  outline: none;
  font-size: ${theme.typography.fontSize.md};
  color: ${theme.colors.text.primary};
  min-width: 0;

  &::placeholder {
    color: ${theme.colors.text.muted};
  }

  &:disabled {
    cursor: not-allowed;
  }
`;
const IconWrapper = styled.span `
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${theme.colors.text.muted};
  flex-shrink: 0;
`;
const ErrorText = styled.span `
  font-size: ${theme.typography.fontSize.sm};
  color: ${theme.colors.status.error};
`;
const HintText = styled.span `
  font-size: ${theme.typography.fontSize.sm};
  color: ${theme.colors.text.muted};
`;
export const Input = forwardRef(function Input({ label, error, hint, fullWidth = false, leftIcon, rightIcon, disabled, id, ...props }, ref) {
    const inputId = id || label?.toLowerCase().replace(/\s+/g, '-');
    return (_jsxs(InputWrapper, { "$fullWidth": fullWidth, children: [label && _jsx(Label, { htmlFor: inputId, children: label }), _jsxs(InputContainer, { "$hasError": !!error, "$disabled": !!disabled, children: [leftIcon && _jsx(IconWrapper, { "$position": "left", children: leftIcon }), _jsx(StyledInput, { ref: ref, id: inputId, disabled: disabled, ...props }), rightIcon && _jsx(IconWrapper, { "$position": "right", children: rightIcon })] }), error && _jsx(ErrorText, { children: error }), hint && !error && _jsx(HintText, { children: hint })] }));
});
